module.exports = {"slug":"craft","title":"Craft","className":"blue","html":"<p>My work is build-to-order custom. I hand-code and am a strong believer in craft, even thought it’s often something that you’ll never even see. Whatever the scope of your need, I always take a mobile-responsive, forward-thinking, holistic approach. My goal is the long-term sustainability of your website, application or experience, and I’ll often invest the time now to ensure versatility later.</p>\n"};


//////////////////
// WEBPACK FOOTER
// ./markdown/craft.md
// module id = 634
// module chunks = 35783957827783